"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Api = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _derives = require("@cennznet/api/util/derives");

var _alias = _interopRequireDefault(require("@cennznet/types/alias"));

var _api = require("@plugnet/api");

var _util = require("@plugnet/util");

var derives = _interopRequireWildcard(require("./derives"));

var _plugins = _interopRequireDefault(require("./plugins"));

var _staticMetadata = _interopRequireDefault(require("./staticMetadata"));

var _getProvider = require("./util/getProvider");

var _injectPlugin = require("./util/injectPlugin");

var _logging = _interopRequireDefault(require("./util/logging"));

// Copyright 2019 Centrality Investments Limited
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//     http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
const Types = require('@cennznet/types');

class Api extends _api.ApiPromise {
  static async create() {
    let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return new Api(options).isReady;
  } // TODO: add other crml namespaces

  /**
   * Generic Asset CRML extention
   */


  constructor() {
    let provider = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    const options = (0, _util.isObject)(provider) && (0, _util.isFunction)(provider.send) ? {
      provider
    } : (0, _objectSpread2.default)({}, provider);

    if (typeof options.provider === 'string') {
      options.provider = (0, _getProvider.getProvider)(options.provider);
    }

    options.metadata = Object.assign(_staticMetadata.default, options.metadata);
    let plugins = options.plugins || [];

    try {
      plugins = (0, _injectPlugin.mergePlugins)(plugins, (0, _plugins.default)());
      (0, _injectPlugin.injectOption)(options, plugins);
    } catch (e) {
      _logging.default.error('plugin loading failed');
    }

    options.types = (0, _objectSpread2.default)({}, Types, options.types, _alias.default);
    options.derives = (0, _derives.mergeDeriveOptions)(derives, options.derives);
    super(options);
    this.genericAsset = void 0;
    this.cennzxSpot = void 0;

    if (plugins) {
      (0, _injectPlugin.injectPlugins)(this, plugins);
    }
  }

}

exports.Api = Api;